import { render, staticRenderFns } from "./LmProcessTypesListbuilder.vue?vue&type=template&id=2b6af6fa"
import script from "./LmProcessTypesListbuilder.vue?vue&type=script&lang=js"
export * from "./LmProcessTypesListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports